import {
  ColorBlockHero,
  Contact,
  ContentPage,
  ContentPageActor,
  Fact,
  GlocalContactModule,
  MediaBackgroundHero,
  MediaContent,
  OptionBlock,
  TextModule,
} from 'models';
import { normalize } from 'pages/api/sitemap';
import { Translations } from 'store/translations';
import { internalPages } from 'utils/getInternalPage';

export const hrefLink = (
  model:
    | ContentPage
    | TextModule
    | MediaContent
    | Fact
    | ColorBlockHero
    | MediaBackgroundHero
    | ContentPageActor
    | Contact
    | OptionBlock
    | GlocalContactModule,
  routerSlug: string | string[] | undefined,
  isContentPage = false,
  locale = process.env.NEXT_PUBLIC_DEFAULT_LOCALE!,
  translations?: Translations,
) => {
  const kontentAiItem = isContentPage
    ? (model as ContentPage | ContentPageActor)
    : (model as TextModule | MediaContent | Fact | ColorBlockHero | MediaBackgroundHero).elements.ctaSnippetKontentAiUrl
        ?.linkedItems[0];
  let url = '';
  if (
    !isContentPage &&
    (model as TextModule | MediaContent | Fact | ColorBlockHero | MediaBackgroundHero).elements.ctaSnippetUrl.value
  )
    url = (model as TextModule | MediaContent | Fact | ColorBlockHero | MediaBackgroundHero).elements.ctaSnippetUrl
      .value;
  else if (kontentAiItem) {
    if (kontentAiItem?.system?.type === 'content_page') {
      const campaignPage = (kontentAiItem as ContentPage).elements.partOfCampaignPage.linkedItems[0] as
        | string
        | ContentPage
        | undefined;
      const campaignUrl =
        campaignPage === '[Circular]' && Array.isArray(routerSlug)
          ? `/${routerSlug}`
          : `/${(campaignPage as ContentPage)?.elements?.url.value}`;

      if (!campaignUrl.includes('undefined')) {
        url = `${locale === process.env.NEXT_PUBLIC_DEFAULT_LOCALE! ? '' : `/${locale}`}${campaignUrl}/${
          (kontentAiItem as ContentPage).elements.url.value
        }`;
      } else if (!url)
        url =
          normalize(kontentAiItem as ContentPage, locale, undefined, false, translations && translations)?.[
            kontentAiItem.system?.codename
          ] ?? '';
    } else if (kontentAiItem?.system?.type === 'content_page_actor') {
      if ((kontentAiItem as ContentPageActor).elements.externalCtaLink.value)
        url = (kontentAiItem as ContentPageActor).elements.externalCtaLink.value;
      else {
        url =
          (translations &&
            internalPages(
              translations,
              (kontentAiItem as ContentPageActor).elements.internalCtaLink.value[0]?.codename,
            )) ??
          '';
      }
    } else
      url =
        normalize(kontentAiItem as ContentPage, locale, undefined, false, translations && translations)?.[
          kontentAiItem.system?.codename
        ] ?? '';
  }
  // Limit URL length to 2048 characters for safety
  if (url.length > 2048) {
    const itemInfo = kontentAiItem
      ? {
          codename: kontentAiItem.system?.codename,
          type: kontentAiItem.system?.type,
          name: kontentAiItem.system?.name,
        }
      : 'Unknown item';

    console.error('🚨 URL LENGTH EXCEEDED:', {
      item: itemInfo,
      urlLength: url.length,
      excess: url.length - 2048,
      url: url.substring(0, 100) + '...', // Log first 100 chars for identification
    });

    // In development, throw an error to catch issues early
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`URL exceeds 2048 characters for item: ${JSON.stringify(itemInfo)}`);
    }

    url = '/';
  }
  return url;
};
